export default __webpack_public_path__ + "static/FoundersGrotesk-Regular-00b0a5532d89cdc1c68713c1e703457d.ttf";